
import { defineComponent, PropType } from 'vue'
import Button from '@/components/AtomButton.vue'

export default defineComponent({
  components: {
    Button
  },
  emits: ['pageChanged'],
  props: {
    currentPage: {
      type: Number as PropType<number>,
      required: true,
      validator: (value: number) => {
        return value > 0
      }
    },
    totalItems: {
      type: Number as PropType<number>,
      required: true,
      validator: (value: number) => {
        return value > 0
      }
    },
    paginationRange: {
      type: Number as PropType<number>,
      default: 2
    },
    perPage: {
      type: Number as PropType<number>,
      default: 20
    },
    prevButton: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    nextButton: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    firstButton: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    lastButton: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  methods: {
    pageChange (page: number) {
      this.$emit('pageChanged', page)
    }
  },
  data () {
    return {
      totalPages: Math.ceil(this.totalItems / this.perPage)
    }
  },
  computed: {
    startRange (): number {
      let aditional: number = this.paginationRange + this.currentPage - this.totalPages
      aditional = aditional > 0 ? aditional : 0
      const start = this.currentPage - this.paginationRange - aditional
      return start > 0 ? start : 1
    },
    stopRange (): number {
      let aditional: number = this.paginationRange - this.currentPage + 1
      aditional = aditional > 0 ? aditional : 0
      const stop = this.currentPage + this.paginationRange + aditional
      return stop < this.totalPages ? stop : this.totalPages
    },
    paginationFrom (): number {
      return (this.currentPage - 1) * this.perPage + 1
    },
    paginationTo (): number {
      const endPage = (this.currentPage * this.perPage)
      return this.totalItems < endPage ? this.totalItems : endPage
    },
    isFirstPage ():boolean {
      return this.currentPage === 1
    },
    isLastPage (): boolean {
      return this.currentPage >= this.totalPages
    },
    getPaginationButtons (): number[] {
      const pages: Array<number> = []
      for (let pageNumber = this.startRange; pageNumber <= this.stopRange; pageNumber++) {
        pages.push(pageNumber)
      }
      return pages
    }
  }
})
